import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { map, mergeAll, toArray } from 'rxjs/operators';
import { FirestoreService } from 'src/app/services/firestore.service';
import { PaginationService } from 'src/app/services/pagination.service';
import * as _ from 'lodash';
import { concat, merge, Observable } from 'rxjs';
import { InfinitScrollService } from 'src/app/services/infinit-scroll.service';

@Component({
  selector: 'app-business-category-list',
  templateUrl: './business-category-list.component.html',
  styleUrls: ['./business-category-list.component.sass']
})

export class BusinessCategoryListComponent implements OnInit {

  popularItems;
  logoImage: string = "./assets/img/no-logo.png";
 

  todos: Array<any> = [];
  batch: number = 4;
  last;
  empty: boolean = false;
  loading: boolean = false;
  
  firstItems;
  nextItems;
  lastDoc;
  items;
  itemsArray: Array<any> = [];
  colName: string = 'businessCategories';

  constructor(    
    private route: Router,
    public db: FirestoreService,
    public page: PaginationService,
    public infinit: InfinitScrollService,
  ) { }
  
  ngOnInit(){  
    this.popularItems = this.db.getPopularBusinessCategoryLists();
    this.firstList()
    
  }

  firstList(){
    this.loading = true;
    this.infinit.firstList(this.colName)
    .get()
    .forEach(snap=>{
      this.lastDoc = snap.docs[snap.docs.length-1]
      snap.forEach(s=>{
        const id = s.id;
        const data = s.data() as any
        const doc = {id, ...data}
        this.itemsArray.push({id, ...data})
      })
    })  
    .then(res=>{
      this.loading = false;
    })
  }

  nextList(){
    this.loading = true;
    this.infinit.nextList(this.colName, this.lastDoc)
    .get()
    .forEach(snap=>{
      this.lastDoc = snap.docs[snap.docs.length-1]
      snap.forEach(s=>{
        const id = s.id;
        const data = s.data() as any;
        const doc = {id, ...data};
        this.itemsArray.push({id, ...data});
      })
    })
    .then(res=>{
      this.loading = false;
    })
  }
  ////////////////////////////////////////////////////

  onScroll () {
    // this.loading = true;~
    // setTimeout(() => {
    //   this.fetchTodosPaginated();
    //   this.loading = false;
    // }, 1500);
  }

  routeToBusinessDetailPage(docId){
    this.route.navigateByUrl('business/details/'+docId)
  };

  routeToBusinessListPage(name){
    this.route.navigateByUrl('businesses/'+name)
  };
  
  routeToBusinessCategoryListPage(){
    this.route.navigateByUrl('business/categories')
  };

  
}
